import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/category-sliders/category-sliders.tsx");
